<ion-item
  [disabled]="isDisabled"
  button
  [ngClass]="{ 'is-not-public-self-help-address': item?.type === 'selfHelpAddress' && item?.isPublished === false }"
  (click)="openDetail.emit(item)">
  <div class="badge-wrapper" slot="start">
    <ng-content></ng-content>
    <ion-badge class="item-badge" [style.--background]="item.indicatorColor || 'var(--skeleton-color)'"></ion-badge>
  </div>
  <ion-label class="ion-text-wrap item-label">
    <h3 class="item-label__title">
      <span class="skeleton">{{ title }}</span>
    </h3>
    @if (showSkeleton || subheadline) {
      <p class="item-label__subheadline">
        <span class="skeleton">{{ subheadline }}</span>
      </p>
    }
  </ion-label>
  @if (showTransparencyLabelIcon) {
    <ion-icon
      class="status-icon"
      slot="end"
      [src]="transparencyLabelIconSrc"
      aria-hidden="true">
    </ion-icon>
  }
  @if (item?.latestDataReview) {
    <ion-icon
      class="status-icon"
      slot="end"
      [name]="item.latestDataReview.status === 'requested'
        ? 'mail-unread-outline'
        : item.latestDataReview.status === 'accepted'
          ? 'checkmark-done-outline'
          : 'hourglass-outline'">
    </ion-icon>
  }
  @if (item?.type === 'selfHelpAddress' && item?.isPublished === false) {
    <ion-icon class="status-icon" slot="end" name="eye-off-outline"></ion-icon>
  }
</ion-item>
